import { FC } from 'react';
import HorizontalScrollList from '#components/lists/horizontal-scroll-list/HorizontalScrollList';
import SpecialTeaser from '#components/teasers/special-teaser/SpecialTeaser';
import { isEuropaParkApp } from '#utils/isEuropaParkApp';
import PageSection from '#components/sections/page-section/PageSection';
import TeaserGridContainer from '#components/lists/teaser-grid/TeaserGridContainer';
import TeaserListRenderer from '#components/lists/teaser-list-renderer/TeaserListRenderer';
import { Teaser } from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  layout?: 'list' | 'grid';
  items: Teaser[];
};

const Recommendations: FC<Props> = ({ items, layout = 'grid' }) => {
  const { t } = useTranslation();

  if (!items?.length) {
    return null;
  }

  if (!isEuropaParkApp()) {
    if (layout === 'grid') {
      return (
        <PageSection title={t('recommendations')}>
          <TeaserGridContainer sc={1} mc={3} lc={4} xlc={4} xxlc={5}>
            <TeaserListRenderer items={items} TeaserComponent={SpecialTeaser} />
          </TeaserGridContainer>
        </PageSection>
      );
    }

    if (layout === 'list') {
      return (
        <PageSection title={t('recommendations')}>
          <HorizontalScrollList
            items={items}
            direction="portrait"
            TeaserComponent={SpecialTeaser}
          />
        </PageSection>
      );
    }
  }

  return null;
};

export default Recommendations;
